var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"partition-erect",style:({ width: _vm.erectWid, height: _vm.erectHei, background: _vm.erectBackGround })})
}
var staticRenderFns = []

export { render, staticRenderFns }